import { Lead } from 'types/entities/Lead'
import { LeadCategory } from 'types/enums/LeadCategory'
import { LeadStatus } from 'types/enums/LeadStatus'

const OPPORTUNITY_STATUSES = new Set<LeadStatus>([
    LeadStatus.NewInquiry,
    LeadStatus.IndicativeOffer,
    LeadStatus.Quotation,
    LeadStatus.OnHold,
    LeadStatus.Acceptance,
    LeadStatus.Rejection,
    LeadStatus.OnlineBooked,
    LeadStatus.Finished,
])

export const isOpportunityLead = (lead?: Partial<Lead> | null): boolean => {
    if (!lead) {
        return false
    }

    if (lead.category === LeadCategory.Opportunity) {
        return true
    }

    if (!lead.status) {
        return false
    }

    return OPPORTUNITY_STATUSES.has(lead.status as LeadStatus)
}

export const splitLeadsAndOpportunities = (leads: Lead[] = []) => {
    const leadItems: Lead[] = []
    const opportunityItems: Lead[] = []

    leads.forEach((lead) => {
        if (isOpportunityLead(lead)) {
            opportunityItems.push(lead)
        } else {
            leadItems.push(lead)
        }
    })

    return {
        leads: leadItems,
        opportunities: opportunityItems,
    }
}

/** Counts for Accounts table columns — split by `category` (and legacy status fallback). */
export const countLeadsAndOpportunities = (leads: Lead[] = []) => {
    const split = splitLeadsAndOpportunities(leads)
    return {
        leads: split.leads.length,
        opportunities: split.opportunities.length,
    }
}
